var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.024
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26386",
    d: "M14.241 2.846h3.18a.58.58 0 01.579.58v15.306a.58.58 0 01-.579.58H2.577a.58.58 0 01-.58-.58V3.426a.58.58 0 01.58-.58h3.18",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26387",
    d: "M12.087 2.194a2.182 2.182 0 00-4.173 0H5.76v2.847h8.481V2.194z",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26388",
    d: "M4.392 8.578l.906.906L7.19 7.592",
    stroke: "#a1ff00"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 687",
    stroke: "#fff",
    d: "M9.541 8.538H15.7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26389",
    d: "M4.392 12.067l.906.906 1.892-1.892",
    stroke: "#a1ff00"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 688",
    stroke: "#fff",
    d: "M9.541 12.026H15.7"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26390",
    d: "M4.33 15.555l.906.906 1.892-1.892",
    stroke: "#a1ff00"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 689",
    stroke: "#fff",
    d: "M9.499 15.516h6.159"
  }))));
}
export default SvgOrder;